import {enableFormBack, handleApiForm} from "../../forms";
import {toastAlert} from "../../toastAlert";
import * as $ from "jquery";
import {pathIs, url} from "../../utilities";
import {invoices_page} from "./invoices";
import axios from "axios";

export const reckonings_page = () => {

    if(pathIs(['/app/reckonings/invoices', '/app/reckonings/invoices/*'])) {
        invoices_page();
    }

    if(pathIs(['/app/reckonings/items', '/app/reckonings/items*'])) {
        $('.itemsTable').DataTable({
            drawCallback: function() {
                this.$('[title]').each(function() {
                    new bootstrap.Tooltip(this, {html: true});
                })
            }
        })
    }

    handleApiForm("#editAssociationAddress", function ({response}) {
        let modalInstance = bootstrap.Modal.getInstance(document.getElementById("editAddressModal"));
        modalInstance.hide();

        toastAlert('Adres został pomyślnie edytowany');

        $('#editAssociation_address').val(response.data.address);
    })

    // Price list table
    let priceListTable = $('#priceListTable');
    if(priceListTable.length > 0) {
        priceListTable = priceListTable.DataTable({
            stateSave: false,
        });

        $("select[name='price_list_type']").change(function() {
            priceListType = $(this).val();
        })

        // Form submit
        $('#editAssociationPriceList, #editCollectionCentre, #editBusinessEntity').submit(function(e) {
            e.preventDefault();

            let inputNames = ['price_1_class', 'price_2_class', 'flat_rate'];

            for(let inputName of inputNames) {
                let inputs = priceListTable.$(`input[name="${inputName}[]"]`);

                inputs.attr('name', `__${inputName}[]`);

                for (let input of inputs) {
                    // Sprawdzamy czy input jest aktywny
                    if ($(input).attr('disabled')) {
                        continue;
                    }

                    $(this).append(`<input type="hidden" name="${inputName}[${$(input).data('animal_type_id')}]" value="${$(input).val()}" />`);
                }
            }

            this.submit();
        })
    }

    $(".btnEditItem").click(function() {
        let modal = $('#editItemModal');
        let row = $(this).closest('tr');
        if(row.hasClass('child')) {
            row = row.prev('tr');
        }

        modal.find('textarea[name="name"]').val(row.find('.item__name').text());
        modal.find('input[name="unit"]').val(row.find('.item__unit').text());
        modal.find('input[name="price"]').val(row.find('.item__price').text());
        modal.find('input[name="vat"]').val(row.find('.item__vat').text());
        modal.find('input[name="code"]').val(row.find('.item__code').text());
        modal.find('input[name="id"]').val(row.data('id'));
    })

    $("#reckoningsAnimalsObtained").submit(function(){
        enableFormBack($(this));
    })

    // edytowanie cen dla poszczególnej zwierzyny - ustawienia
    if(pathIs('/app/reckonings/settings')) {
        $('.btnEditAnimalsPrice').click(async function (){
            let id = $(this).data('id');
            let type_price_id = $(this).data('type_price_id');
            try {
                let response = await axios.get(url('api/reckonings/settings/get-animal-data?id=' + id + '&type_price_id=' + type_price_id));
                let prices = response.data.prices;

                let modal = $("#editAnimalPriceModal");
                let table = modal.find(`table`);

                    table.find('tbody').empty();
                    modal.find('.animal-name').html(response.data.type_name);

                if(prices.length > 1) {
                    for (let animal of prices) {
                        let row = (`<tr data-id="${animal['animal_id']}">
                                    <td>${animal['animal_name']} <input type="hidden" name="animal_ids[]" value="${animal['animal_id']}"></td>
                                    <td><input type="number" class="form-control form-control-sm" name="price_1_class[]" step="0.01" min="0" value="${animal['price_1_class'] ?? ''}"></td>
                                    <td><input type="number" class="form-control form-control-sm" name="price_2_class[]" step="0.01" min="0" value="${animal['price_2_class'] ?? ''}"></td>
                                    <td><input type="number" class="form-control form-control-sm" name="flat_rate[]" step="0.01" min="0" value="${animal['flat_rate'] ?? ''}"></td>
                              </tr>`);
                        table.append(row);

                    }

                    $('#animalTypePriceList').val($(this).data('type_price_id'));
                }else{
                    toastAlert('Błąd. Wybrany gatunek zawiera jedynie jeden rodzaj zwierzyny.', {type: 'danger'});
                }

            }catch(err){
                toastAlert('Wystąpił błąd poczas ładowania danych. Spróbuj ponownie później.', {type: 'danger'});
            }

        })
    }

    if(pathIs('/app/reckonings/collection-centres/*')) {

        $('.btnEditAnimalsCCPrice').click(async function (){
            let id = $(this).data('id');
            let type_price_id = $(this).data('type_cc_price_id');
            let centre_id = $(this).data('centre_id');

            try {
                let response = await axios.get(url('api/reckonings/collection-centres/get-animal-data?id=' + id + '&type_price_id=' + type_price_id + '&centre_id=' + centre_id));

                let prices = response.data.prices;
                let modal = $("#editAnimalCCPriceModal");
                let table = modal.find(`table`);
                table.find('tbody').empty();
                modal.find('.animal-name').html(response.data.type_name);

                if(prices.length > 1) {
                    for (let animal of prices) {
                        let row = (`<tr data-id="${animal['animal_id']}">
                                    <td>${animal['animal_name']} <input type="hidden" name="animal_ids[]" value="${animal['animal_id']}"></td>
                                    <td><input type="number" class="form-control form-control-sm" name="price_1_class[]" step="0.01" min="0" value="${animal['price_1_class'] ?? ''}"></td>
                                    <td><input type="number" class="form-control form-control-sm" name="price_2_class[]" step="0.01" min="0" value="${animal['price_2_class'] ?? ''}"></td>
                                    <td><input type="number" class="form-control form-control-sm" name="flat_rate[]" step="0.01" min="0" value="${animal.flat_rate ?? ''}"></td>
                              </tr>`);
                        table.append(row);
                    }

                    $('#animalTypeCCPriceList').val($(this).data('type_cc_price_id'));

                }else{
                    toastAlert('Błąd. Wybrany gatunek zawiera jedynie jeden rodzaj zwierzyny.', {type: 'danger'});
                }
            }catch(err){
                toastAlert('Wystąpił błąd poczas ładowania danych. Spróbuj ponownie później.', {type: 'danger'});
            }

        })
    }

    if(pathIs('/app/reckonings/business-entities/*')) {


        $('.btnEditAnimalsBEPrice').click(async function (){

            let id = $(this).data('id');
            let type_price_id = $(this).data('type_be_price_id');
            let entity_id = $(this).data('entity_id');

            try {
                let response = await axios.get(url('api/reckonings/business-entities/get-animal-data?id=' + id + '&type_price_id=' + type_price_id + '&entity_id=' + entity_id));
                let prices = response.data.prices;

                let modal = $("#editAnimalBEPriceModal");
                let table = modal.find(`table`);
                table.find('tbody').empty();
                modal.find('.animal-name').html(response.data.type_name);

                if(prices.length > 1) {
                    for (let animal of prices) {
                        let row = (`<tr data-id="${animal['animal_id']}">
                                    <td>${animal['animal_name']} <input type="hidden" name="animal_ids[]" value="${animal['animal_id']}"></td>
                                    <td><input type="number" class="form-control form-control-sm" name="price_1_class[]" step="0.01" min="0" value="${animal['price_1_class'] ?? ''}"></td>
                                    <td><input type="number" class="form-control form-control-sm" name="price_2_class[]" step="0.01" min="0" value="${animal['price_2_class'] ?? ''}"></td>
                                    <td><input type="number" class="form-control form-control-sm" name="flat_rate[]" step="0.01" min="0" value="${animal['flat_rate'] ?? ''}"></td>
                              </tr>`);
                        table.append(row);
                    }

                    $('#animalTypeBEPriceList').val($(this).data('type_be_price_id'));
                }else{
                    toastAlert('Błąd. Wybrany gatunek zawiera jedynie jeden rodzaj zwierzyny.', {type: 'danger'});
                }
            }catch(err){
                toastAlert('Wystąpił błąd poczas ładowania danych. Spróbuj ponownie później.', {type: 'danger'});
            }

        })
    }

    }
